var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuResourcesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2489_37017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01465 5.76172H6.83886V11.2408H4.01465V5.76172Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6025 6.20896L13.3566 5.50244C13.8452 7.2673 14.3337 9.02929 14.8246 10.8022L12.0907 11.5087C11.5974 9.74498 11.1024 7.98528 10.6025 6.20896Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3753 11.2467H7.58203V5.76709H10.3783L10.3753 11.2467Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59976 5.06275C7.59976 4.56251 7.59085 4.0852 7.60333 3.60846C7.61106 3.31279 7.84106 3.04921 8.14535 3.03545C8.70223 3.00852 9.26089 3.01826 9.81896 3.0303C10.0418 3.03488 10.2059 3.16782 10.3075 3.35748C10.3527 3.44171 10.4008 3.44171 10.4858 3.41879C10.9898 3.28242 11.4932 3.14146 12.0025 3.02571C12.1564 2.98829 12.3193 3.00843 12.4585 3.0821C12.5976 3.15577 12.7027 3.2775 12.7525 3.42281C12.8922 3.81417 12.998 4.21699 13.1174 4.61466C13.1365 4.67884 13.1525 4.74358 13.1769 4.82438L10.4234 5.5309C10.3901 5.41629 10.3521 5.31373 10.3325 5.20772C10.3128 5.10171 10.2617 5.05645 10.1363 5.05759C9.33934 5.06275 8.54295 5.06275 7.74478 5.06275H7.59976Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2725 12.1834L15.0129 11.4746C15.1448 11.9599 15.2857 12.4304 15.3956 12.9071C15.4551 13.1724 15.2589 13.4882 14.9879 13.5695C14.4827 13.7202 13.974 13.8635 13.4593 13.9781C13.079 14.0629 12.7735 13.8921 12.6552 13.5351C12.5096 13.0956 12.4014 12.6453 12.2725 12.1834Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.02787C4 4.72589 4 4.43252 4.00297 4.13627C3.99701 3.9597 4.00118 3.78294 4.01545 3.60681C4.05943 3.2378 4.30429 3.01776 4.68882 3.0086C5.17379 2.99713 5.65915 2.99713 6.14491 3.0086C6.5437 3.01834 6.80876 3.2378 6.83075 3.60624C6.85928 4.07611 6.83789 4.54826 6.83789 5.0273L4 5.02787Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5803 11.916H10.3463C10.354 11.9344 10.3593 11.9537 10.3623 11.9733C10.3623 12.4266 10.3712 12.8798 10.3552 13.3325C10.3421 13.7118 10.1091 13.937 9.71867 13.9467C9.21944 13.9594 8.71962 13.9576 8.22039 13.9467C7.86855 13.9382 7.60467 13.7175 7.58684 13.3835C7.56069 12.9004 7.5803 12.4145 7.5803 11.916Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00347 11.9543H6.85264C6.82887 12.4603 6.82174 12.96 6.77657 13.4568C6.7528 13.7204 6.47466 13.9392 6.19711 13.9455C5.69312 13.9576 5.18676 13.961 4.68396 13.9513C4.27626 13.9444 4.01773 13.694 4.00644 13.3003C3.99396 12.8557 4.00347 12.4139 4.00347 11.9543Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2489_37017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4074,
    height: 11,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuResourcesIcon);
export default __webpack_public_path__ + "static/media/menu-resources-icon.0aa4850b48ca3806fc536b274ef7b9c3.svg";
export { ForwardRef as ReactComponent };